import { Injectable } from '@angular/core';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  constructor() {}

  test = 'test';

  VARIABLE = {
    
    partsAcctNo: { ID: 1 },
    region: { ID: 2 },
    NAM: { ID: 3 },
    NAMEmail: { ID: 4 },
    FINNumber: { ID: 5 },
    requestor: { ID: 6 },
    team: { ID: 7 },
    RSM: { ID: 8 },
    languaje: { ID: 9 },
    accepRom: { ID: 10 },
    accepAir: { ID: 11 },
    cdsid: { ID: 12 },
    respHotel: { ID: 13 },
    respAir: { ID: 14 },
    phoneAcknowledgment: {ID:15},
    redressCheck: { ID:16 }
  };

  toCheckBoxModel(actual, keys, delimiters?) {
    if (!keys) {
      return undefined;
    }
    const model = {};
    if (!actual) {
      return model;
    }
    const split = actual.split(delimiters ? delimiters : /,+ */);
    return _.values(keys).reduce((a, c) => {
      a[c] = split.indexOf(c) >= 0;
      return a;
    }, model);
  }

  toDelimitedKeysString(c, delimiters?) {
    if (!c) {
      return '';
    }
    return _.keys(c)
      .filter(k => {
        return c[k];
      })
      .join(delimiters ? delimiters : ', ');
  }
}
